import { TeamColors, TeamColorsValues } from '../common.type';
import styled from 'styled-components';
import { Displays, DisplaysValues } from '../type';

export const Coin = styled.div<{
  color: TeamColorsValues;
  $displayMode: DisplaysValues;
}>`
  position: absolute;
  width: ${(props) =>
    props.$displayMode === Displays.LANDSCAPE ? '4vmin' : '6vmin'};
  height: ${(props) =>
    props.$displayMode === Displays.LANDSCAPE ? '4vmin' : '6vmin'};
  top: 0;
  margin-top: -1.5vmin;
  ${(props) =>
    props.color === TeamColors.BLUE &&
    `
      left:0;
      margin-left:-1.5vmin;
      background:url(${process.env.PUBLIC_URL}/images/coin-blue.webp) no-repeat;
      `};
  ${(props) =>
    props.color === TeamColors.RED &&
    `
      right:0;
      margin-right:-1.5vmin;
      background:url(${process.env.PUBLIC_URL}/images/coin-red.webp) no-repeat;
    `};
  background-size: contain;
`;
